import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useParams } from "react-router-dom";
import { Box, Typography, Breadcrumbs, Link, Paper,makeStyles,Divider } from '@material-ui/core';
import { Home as HomeIcon, NavigateNext as NavigateNextIcon } from '@material-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import SendIcon from '@material-ui/icons/Send';
import DashboardIcon from "@material-ui/icons/Dashboard";
import PublishIcon from '@material-ui/icons/Publish';
import SettingsIcon from '@material-ui/icons/Settings';
import ReportIcon from '@material-ui/icons/Report';
const useStyles = makeStyles((theme) => ({
  root1: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  
}));
   
const Toolbar = ({ className, ...rest }) => {
  const classes = useStyles();
  var { auctionName } = useParams();
  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    > 
 
 <Box style={{ padding: '24px'}}>
      {/* Breadcrumb */}
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        style={{ marginBottom: 16 }}   
      >
        <Link
          color="textPrimary"
          component={RouterLink}
          to="/app/dashboard"
          style={{ display: 'flex', alignItems: 'center', color: '#333', fontWeight: 300 }}
        >
          <DashboardIcon fontSize="small" style={{ marginRight: 4 }} />
          Dashboard
        </Link>   
        <Link
          color="textPrimary"  
          // component={RouterLink}
          // to="/auctions"
          style={{ display: 'flex', alignItems: 'center', color: '#333', fontWeight: 300 }}
        >
          
          Invoice
        </Link>
         <Link
          color="textPrimary"  
          // component={RouterLink}
          // to="/auctions"
          style={{ display: 'flex', alignItems: 'center', color: '#333', fontWeight: 300 }}
        >
          
          Bulk Invoice Upload
        </Link>
        
        {/* <Typography style={{ fontWeight: 600, color: '#000' }}>
          {auctionName}
        </Typography> */}
      </Breadcrumbs>

      {/* Header Card */}
     
      
        <Box>
          <Typography variant="h5" style={{ fontWeight: 'bold', color: '#000' }}>
            Bulk Invoice Upload
          </Typography>
          <Typography variant="body2" style={{ color: '#555' ,marginTop:"5px"}}>
              Upload an Excel file to import multiple invoice at once.
          </Typography>
        </Box>   
     
    </Box>
      </div>
           
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
 